<template>
  <div class="download-wrap">
    <div id="download-pic" :style="style">
      <div
        class="download-container"
        :style="{
          transform: `rotate(${rotate}deg)`,
          'transform-origin': 'center center'
        }"
      >
        <el-image ref="img" :src="src" @load="onLoad" />

        <div class="insects-rect">
          <div
            class="model-insect"
            v-for="item in insects"
            :key="item.id"
            :class="{
              [`category-${item.categoryId}`]: true
            }"
            :style="insectStyle(item)"
          >
            <div class="model-insect__name">{{ item.category }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import path from 'path'

export default {
  props: {
    src: String,
    insects: Array
  },
  data() {
    return {
      iw: 0,
      ih: 0
    }
  },
  computed: {
    rotate() {
      // return this.iw < this.ih ? 90 : 0
      return 90
    },
    style() {
      const { iw, ih, rotate } = this
      return rotate === 90
        ? { width: `${ih}px`, height: `${iw}px` }
        : { width: `${iw}px`, height: `${ih}px` }
    }
  },
  methods: {
    onLoad(evt) {
      const img = evt.target
      const width = img.naturalWidth
      const height = img.naturalHeight
      this.iw = width
      this.ih = height

      this.$nextTick(() => {
        this.download()
      })
    },
    download() {
      const el = document.getElementById('download-pic')
      html2canvas(el)
        .then(canvas => {
          const imUrl = canvas.toDataURL('image/jpeg')
          let link = document.createElement('a')
          link.setAttribute('download', path.basename(this.src))
          link.href = imUrl
          link.click()
        })
        .then(() => {
          document.body.removeChild(this.$el)
        })
    },
    insectStyle(item) {
      const width = Math.max(item.tailPositionX - item.headPositionX, 0.005)
      const height = Math.max(item.tailPositionY - item.headPositionY, 0.005)
      return {
        width: `${width * this.iw}px`,
        height: `${height * this.ih}px`,
        left: `${item.headPositionX * this.iw}px`,
        top: `${item.headPositionY * this.ih}px`
      }
    }
  }
}
</script>

<style lang="css" scoped>
.download-wrap {
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
}
#download-pic {
  overflow: hidden;
}
.download-container {
  overflow: hidden;
}
.insects-rect {
  width: 100%;
  height: 100%;
}
.model-insect {
  position: absolute;
  border: 2px solid #fff;
}
.model-insect__name {
  transform: rotate(-90deg);
  position: absolute;
  top: calc(100% - 28px);
  left: -2rem;
  color: #fff;
  text-align: left;
  text-shadow: 1px 1px 8px #000;
}
</style>
